const timeZoneList = () => import('../assets/file/timeZoneList.json')

export default {
  DEFAULT_LANGUAGE: 'en',
  FALLBACK_LANGUAGE: 'en',
  KEYCLOAK_ROLES: {
    ADMIN: 'admin',
    USER: 'user'
  },
  TIME_ZONE_LIST: timeZoneList(),
  TIME_FORMAT: {
    DD_MM_YYYY_HH_mm_ss_A: 'DD/MM/YYYY hh:mm:ss A',
    DD_MM_YYYY: 'DD/MM/YYYY',
    YYYY_MM_DD: 'YYYY-MM-DD',
    HH_mm: 'HH:mm'
  },
  STATUS_CODE: {
    INVALID_REPO_URL: 101
  },
  REPORT_TYPE: {
    // 'stash': 1,
    'rank': 2,
    'workload': 3,
    // 'compare': 4
  },
  REPORT_TYPES: [
    // { id: 1, name: 'stash' },
    { id: 2, name: 'rank' },
    { id: 3, name: 'workload' },
    // { id: 4, name: 'compare' }
  ],
  DURATION_TYPES: [
    { id: 0, name: 'daily' },
    { id: 1, name: 'weekly' },
    { id: 2, name: 'monthly' },
  ],
  DURATION_TYPE: {
    'daily': 0,
    'weekly': 1,
    'monthly': 2
  },
  WEEK: {
    0: 'sun',
    1: 'mon',
    2: 'tue',
    3: 'wed',
    4: 'thu',
    5: 'fri',
    6: 'sat'
  },
  DAY_OF_WEEK_NUMBER: 7,
  DAY_IN_MILLISECOND: 86400000,
  HOUR_IN_MILLISECOND: 3600000,
  PERIOD_OPTIONS: [
    { id: 1, name: '1 Weeks', value: 1, type: 'week' },
    { id: 2, name: '2 Weeks', value: 2, type: 'week' },
    { id: 3, name: '3 Weeks', value: 3, type: 'week' },
    { id: 4, name: '4 Weeks', value: 4, type: 'week' },
    { id: 5, name: '5 Weeks', value: 5, type: 'week' },
    { id: 6, name: '6 Weeks', value: 6, type: 'week' }
  ],
  WEEK_STR: 'week',
  DAYS_OF_WEEK: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
  MONTHS: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
  INTEGRATION_TYPE: [{
    id: 0,
    label: 'Gitlab'
  }, {
    id: 1,
    label: 'Azure Devops'
  }
  ],
  INTEGRATION_MAP: {
    GITLAB: 0,
    AZURE_DEVOPS: 1
  },
  DATE_RANGE_BUNDLE: {
    TODAY: 'ranges.today',
    YESTERDAY: 'ranges.yesterday',
    ONE_WEEK_AGO: 'ranges.one_week_ago',
    TWO_WEEKS_AGO: 'ranges.two_week_ago',
    THIS_MONTH: 'ranges.this_month',
    LAST_MONTH: 'ranges.last_month',
    THIS_YEAR: 'ranges.this_year',
  },
  INTEGRATION_TYPE_STR: {
    AZURE_DEVOPS: 'azuredevops'
  },
  MAGIC_INFINITY: 10000000
}



// WEBPACK FOOTER //
// ./src/common/common-constant.js